import React from 'react';
import styles from '../CustomizePageSection/CustomizePageSection.module.less';
import RenderEcmRichText from '../../../components/Text/RenderEcmRichText';
import cx from 'classnames';

const TextSection = ({ ecmContent }) => {
  return (
    <RenderEcmRichText
      className={cx([styles.text_content, 'text-content'])}
      content={ecmContent.textContent}
    />
  );
};

export default TextSection;
